import { useState } from "react";
import { IRestaurantTable } from "../models/IReservation";
import { deleteRestaurantTable } from "../services/reservationService";

interface Props {
  table: IRestaurantTable;
  onClose: () => void;
  onDeleted: () => void;
}

export default function DeleteTableModal({ table, onClose, onDeleted }: Props) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = () => {
    setDeleting(true);
    setError("");
    deleteRestaurantTable(table.id)
      .then(() => {
        onDeleted();
        onClose();
      })
      .catch(() => setError("Masa silinemedi."))
      .finally(() => setDeleting(false));
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(3px)" }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: "#fff", borderRadius: 20, padding: "26px 26px 22px", width: "min(96vw, 380px)", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <i className="bi bi-exclamation-triangle-fill" style={{ color: "#dc2626", fontSize: "1.15rem" }}></i>
          </div>
          <div style={{ fontWeight: 800, fontSize: "1rem", color: "#111827" }}>
            Masayı Sil
          </div>
        </div>

        <div style={{ fontSize: "0.88rem", color: "#4b5563", lineHeight: 1.5, marginBottom: 6 }}>
          <b>Masa {table.tableNumber} — {table.label}</b> masasını silmek istediğinize emin misiniz?
        </div>
        <div style={{ fontSize: "0.8rem", color: "#9ca3af", marginBottom: 18 }}>
          Bu işlem geri alınamaz.
        </div>

        {error && (
          <div style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 10, padding: "8px 12px", color: "#b91c1c", fontSize: "0.82rem", marginBottom: 14 }}>
            <i className="bi bi-exclamation-circle me-1"></i>{error}
          </div>
        )}

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onClose}
            style={{ padding: "9px 18px", borderRadius: 10, border: "1.5px solid #e5e7eb", background: "#fff", color: "#6b7280", fontWeight: 600, fontSize: "0.85rem", cursor: "pointer" }}>
            Vazgeç
          </button>
          <button onClick={handleDelete} disabled={deleting}
            style={{
              padding: "9px 22px", borderRadius: 10, border: "none",
              background: "linear-gradient(135deg, #ef4444, #dc2626)",
              color: "#fff", fontWeight: 700, fontSize: "0.85rem",
              cursor: deleting ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", gap: 7,
              opacity: deleting ? 0.7 : 1,
            }}
          >
            {deleting
              ? <><span className="spinner-border spinner-border-sm"></span> Siliniyor...</>
              : <><i className="bi bi-trash-fill"></i> Sil</>
            }
          </button>
        </div>
      </div>
    </div>
  );
}
